import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { doSetServicesActiveBeam } from 'redux/actions';

import CustomBeamRankItem from './CustomBeamRankItem/CustomBeamRankItem';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';

import './CommissionHBFServiceScreen.css';
import { isValidInteger } from 'common/utils/helpers';
import { SCREEN_INDEXES } from '../utils';

const CommissionHBFServiceScreen = ({ onClose, onNext, commissioningId, clearTimeoutAndInterval, selectedDevices }) => {
  const dispatch = useDispatch();

  const [hbfServices, setHbfServices] = useState([]);
  const [azElInputErrors, setAzElInputErrors] = useState(null);

  useEffect(() => {
    const currentHbfServices = selectedDevices
      .filter((service) => service.productType === 'HBF_SERVICE')
      .map((service) => ({
        deviceId: service.deviceId,
        az: '',
        el: ''
      }));

    const currentAzElInputErrors = {};
    currentHbfServices.forEach((service) => {
      currentAzElInputErrors[service.deviceId] = { az: null, el: null };
    });

    setHbfServices(currentHbfServices);
    setAzElInputErrors(currentAzElInputErrors);
  }, [selectedDevices]);

  const setCustomAzEl = (id, values) => {
    const updatedServices = hbfServices.map((service) => {
      if (id === service.deviceId) {
        return { ...service, ...values };
      }
      return service;
    });
    setHbfServices(updatedServices);
  };

  const setAzElError = (id, error) => {
    setAzElInputErrors((state) => ({
      ...state,
      [id]: error
    }));
  };

  const onDone = () => {
    const payload = hbfServices.map((service) => ({
      deviceId: service.deviceId,
      azimuth: service.az,
      elevation: service.el
    }));

    dispatch(
      doSetServicesActiveBeam(commissioningId, payload, () => {
        onNext(SCREEN_INDEXES.HBF_SERVICE, null);
      })
    );
  };

  const isSubmitBtnDisabled = () => {
    let isDisabled = false;

    if (!azElInputErrors) {
      return false;
    }

    Object.values(azElInputErrors).forEach((item) => {
      if (item.az !== null || item.el !== null) {
        isDisabled = true;
      }
    });

    hbfServices.forEach((customAzEl) => {
      if (
        customAzEl.az === null ||
        customAzEl.el === null ||
        customAzEl.az === '' ||
        customAzEl.el === '' ||
        !isValidInteger(customAzEl.az) ||
        !isValidInteger(customAzEl.el)
      ) {
        isDisabled = true;
      }
    });

    return isDisabled;
  };

  return (
    <div className="CommissionHBFServiceScreen_Container">
      <div className="CommissionHBFServiceScreen_Header">Az and El Value for HBF</div>
      <div className="CommissionHBFServiceScreen_Description">
        Your pivot system has a subscriber unit with an HBF antenna. Please
        <br />
        specify the azimuth an elevation to point your SU to.
      </div>
      <div className="CommissionHBFServiceScreen_Content">
        {hbfServices.map((service, idx) => {
          const currentAzElInputError = azElInputErrors[service.deviceId];

          return (
            <div key={idx}>
              <div className="CommissionHBFServiceScreen_Service_Label">
                <div>
                  <SvgAF img={IconLoader.icon_service} hover={IconLoader.icon_service} />
                </div>
                <div className="CommissionHBFServiceScreen_Service_Label_Text">
                  PIVOT SU <span style={{ color: '#F36E21' }}>HBF</span>
                </div>
              </div>
              <CustomBeamRankItem
                key={idx}
                customAzEl={service}
                setCustomAzEl={setCustomAzEl}
                azElInputError={currentAzElInputError}
                setAzElInputError={setAzElError}
              />
              <div className="CommissionHBFServiceScreen_AzElInputError_Container">
                {currentAzElInputError &&
                  Object.keys(currentAzElInputError).map((item, idx) => {
                    return (
                      <span key={idx} className="CommissionHBFServiceScreen_AzElInputError_Text">
                        {currentAzElInputError[item]}
                      </span>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
      <div className="CommissionHBFServiceScreen_BottomContainer">
        <button
          type="submit"
          className={classnames({
            CommissionHBFServiceScreen_Bottom_CancelButton: true
          })}
          onClick={() => {
            clearTimeoutAndInterval();
            onClose();
          }}
        >
          Close
        </button>
        <button
          type="submit"
          className={classnames({
            CommissionHBFServiceScreen_Bottom_DoneButton: true,
            CommissionHBFServiceScreen_Bottom_DoneButton_Disabled: isSubmitBtnDisabled()
          })}
          onClick={() => onDone()}
        >
          Start Commissioning
        </button>
      </div>
    </div>
  );
};

export default CommissionHBFServiceScreen;
